import { getFetch } from '@/plugins/http'
import { postFetch } from '@/plugins/http'

const baseHost = `${process.env.VUE_APP_HOST}`
const commonApiBaseUrl = `${baseHost}/hike-boot/common/api`

export default {
  /**
   * 保存浏览点击量
   */
  saveBrowseClick(params) {
    return postFetch(`${baseHost}/hike-boot/browse/saveBrowseClick`, params)
  },
  /**
   * 基础配置信息
   */
  getBaseSet(params) {
    return getFetch(`${commonApiBaseUrl}/32-base_info/common_config`, params)
  },
  // 项目状态
  getObjectStatus(params, config) {
    return getFetch(`${commonApiBaseUrl}/32-project_status/common_config`, params, config)
  },
  // 项目已开启功能
  getObjectOpenFunction(params, config) {
    return getFetch(`${commonApiBaseUrl}/33-enabled_function/common_config`, params, config)
  },
  // 登录方式文字
  getProjectLogin() {
    return getFetch(`${commonApiBaseUrl}/33-kcsz_case_center/kcsz_case_center `)
  },
  /**
   * 校验ticket
   * @param {String}} ticket
   * @param {String} service 跳转URL
   */
  validateTicket(params = {}) {
    return getFetch(`${baseHost}/hike-boot/sys/validate`, params)
  },
  /**
   * 通过token获取用户信息
   */
  getUserInfo(params = {}) {
    return getFetch(`${baseHost}/hike-boot/sys/user/info`, params)
  },
  /**
   * 登录
   */
  getLogin(params = {}) {
    return postFetch(`${baseHost}/hike-boot/sys/login`, params, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
  },
  /**
   * 用户是否绑定手机-工号登录时
   */
  userBindPhoneInfo(params = {}) {
    return getFetch(`${baseHost}/hike-boot/user/userBindPhoneInfo`, params)
  },
  /**
   * 用户是否允许绑定手机
   */
  bindPhoneInfo(params = {}, config) {
    return getFetch(`${baseHost}/hike-boot/user/bindPhoneInfo`, params, config)
  },
  /**
   * 用户绑定手机号
   */
  userBindPhone(params = {}, config) {
    return getFetch(`${baseHost}/hike-boot/user/userBindPhone`, params, config)
  },
  /**
   * 用户绑定-验证码
   */
  sendBindSmsCode(params = {}, config) {
    return postFetch(`${baseHost}/hike-boot/basicSendSms/sendSmsCode`, params, config)
  },
  /**
   * 发送短信验证码
   */
  sendSmsCode(params = {}, config) {
    return postFetch(`${baseHost}/hike-boot/sendSms/sendSmsCode`, params, config)
  },
  /**
   * 发送短信验证码-注册
   */
  sendRegisterCode(params = {}, config) {
    return postFetch(`${baseHost}/hike-boot/api/basicSendSms/sendSmsCode`, params, config)
  },
  /**
   * 验证码验证
   */
  validateCode(params = {}, config) {
    return postFetch(`${baseHost}/hike-boot/sendSms/validateCode`, params, config)
  },
  /**
   * 确认重置, 通过手机号修改密码
   */
  resetPass(params = {}, config) {
    return getFetch(`${baseHost}/hike-boot/user/revisePasswordByPhone`, params, config)
  },
  /**
   * 确认注册
   */
  confirmRegisterCode(params = {}, config) {
    return postFetch(`${baseHost}/hike-boot/user/registration`, params, config)
  },
  /**
   * 退出登录
   */
  logOut(params = {}, config) {
    return postFetch(`${baseHost}/hike-boot/sys/logout`, params, config)
  },
  /**
   * 导航列表
   */
  getNavList(params) {
    return getFetch(`${commonApiBaseUrl}/33-nav_list/portal_homepage`, params)
  },
  /**
   * 高级设置详情
   */
  getHighSetting(params) {
    return getFetch(`${commonApiBaseUrl}/33-getHighSetting/menu_high_setting`, params)
  },
  /**
   * 案例展示列表
   */
  getCaseList(params) {
    return getFetch(`${commonApiBaseUrl}/34-getCaseShowPageList/case_centre_homepage`, params)
  },
  /**
   * 获取思政元素
   */
  getIdeologyList(params = {}) {
    return getFetch(`${commonApiBaseUrl}/32-ideology/case_center`, params)
  },
  /**
   * 课程展示列表
   */
  getCourseList(params) {
    return getFetch(`${commonApiBaseUrl}/34-getCourseShowPageList/case_centre_homepage`, params)
  },
  /**
   * 课程类型列表
   */
  getCourseTypeList(params) {
    return getFetch(`${commonApiBaseUrl}/33-getCourseTypeList/case_center`, params)
  },

  //获取阿里云上传签名
  getPolicy(data) {
    return postFetch(`${baseHost}/hike-boot/file/getPolicy`, data)
  },

  /**
   * 案例中心_学院树
   */
  getCaseOrganTree(params = {}) {
    return getFetch(`${commonApiBaseUrl}/33-organ_cqu_tree/case_center`, params)
  },

  /**
   * 案例中心筛选学院树
   */
  getCaseFilterOrgTree(params = {}) {
    return getFetch(`${commonApiBaseUrl}/33-organ_tree/case_centre_homepage`, params)
  },
  /**
   * 案例中心_适用专业树
   */
  getCaseMajorList(params = {}) {
    return getFetch(`${commonApiBaseUrl}/33-major_tree/case_center`, params)
  },

  /**
   * 用户详情
   */
  getUserDetail(params, config) {
    return getFetch(`${baseHost}/hike-boot/common/api/32-getUserInfo/manage_user`, params, config)
  },
  /**
   * 用户最后登录时间
   */
  getLastLogin(params, config) {
    return getFetch(
      `${baseHost}/hike-boot/common/api/32-getUserLoginTime/manage_user`,
      params,
      config
    )
  },
  /**
   * 账号设置-修改
   */
  changeInfo(params, config) {
    return postFetch(
      `${baseHost}/hike-boot/common/api/20-updateUserByLoginId/manage_user`,
      params,
      config
    )
  },
  /**
   * 职称列表
   */
  getTitleList(params, config) {
    return getFetch(`${baseHost}/hike-boot/common/api/34-title_list/manage_base`, params, config)
  },
  // 基础设置_专业_列表
  getAllMajorList(params, config) {
    return getFetch(`${baseHost}/hike-boot/common/api/33-majors_tj/manage_base`, params, config)
  },
  /**
   * 发送短信验证码
   */
  getBasicMessage(params = {}, config) {
    return postFetch(`${baseHost}/hike-boot/api/basicSendSms/sendSmsCode`, params, config)
  },
  /**
   * 验证码验证-基本信息（账号设置修改手机号、登录页注册）
   */
  validateBasicCode(params = {}, config) {
    return postFetch(`${baseHost}/hike-boot/api/basicSendSms/validateCode`, params, config)
  },
  /**
   * 发送短信验证码-修改认证信息
   */
  getAuthMessage(params = {}, config) {
    return postFetch(`${baseHost}/hike-boot/authSendSms/sendSmsCode`, params, config)
  },
  /**
   * 验证密码
   */
  validatePassword(params = {}, config) {
    return getFetch(`${baseHost}/hike-boot/user/certificationPassword`, params, config)
  },
  /**
   * 验证码验证-认证信息
   */
  validateAuthCode(params = {}, config) {
    return postFetch(`${baseHost}/hike-boot/authSendSms/validateCode`, params, config)
  }
}
